export enum RecorderType {
    bittium = 'bittium',
    fysiologic = 'fysiologic',
}
